// src/api/activiteReseau.ts — SCE Issues
// Compteur des requêtes Graph / SharePoint en cours.
//
// Pourquoi : l'écran d'ouverture de session (Lot 11) reste affiché jusqu'à ce
// que la page d'arrivée ait chargé ses listes — accueil, liste, fiche ouverte
// depuis un mail… Plutôt que d'apprendre à chaque page à dire « je suis
// prête », on observe le seul point de passage commun : graphClient et
// sharepointClient. Quand plus rien n'est en vol pendant un instant, la page
// est prête.

type Ecouteur = (enCours: number) => void

let enCours = 0
const ecouteurs = new Set<Ecouteur>()

function prevenir(): void {
  for (const e of ecouteurs) e(enCours)
}

/** Enveloppe une requête : comptée du départ jusqu'à la réponse (ou l'échec). */
export async function suivreRequete<T>(requete: () => Promise<T>): Promise<T> {
  enCours++
  prevenir()
  try {
    return await requete()
  } finally {
    enCours--
    prevenir()
  }
}

/** Abonnement aux changements du compteur ; renvoie la fonction de désabonnement. */
export function ecouterReseau(ecouteur: Ecouteur): () => void {
  ecouteurs.add(ecouteur)
  return () => {
    ecouteurs.delete(ecouteur)
  }
}

/**
 * Résout quand aucune requête n'a été en vol pendant `calmeMs` d'affilée, ou
 * au bout de `plafondMs` quoi qu'il arrive (une page qui pagine longuement
 * ne doit pas retenir l'écran de chargement).
 *
 * Le calme doit DURER : juste après l'ouverture de session, les pages n'ont
 * pas encore lancé leurs requêtes ; et deux requêtes qui s'enchaînent laissent
 * un creux de quelques millisecondes.
 */
export function attendreReseauCalme(calmeMs: number, plafondMs: number): Promise<void> {
  return new Promise((resoudre) => {
    let minuterieCalme: ReturnType<typeof setTimeout> | undefined
    const finir = (): void => {
      clearTimeout(minuterieCalme)
      clearTimeout(plafond)
      desabonner()
      resoudre()
    }
    const surveiller = (n: number): void => {
      clearTimeout(minuterieCalme)
      if (n === 0) minuterieCalme = setTimeout(finir, calmeMs)
    }
    const plafond = setTimeout(finir, plafondMs)
    const desabonner = ecouterReseau(surveiller)
    surveiller(enCours)
  })
}
